import styled from 'styled-components';

import { COLORS } from '../../../../theme/tokens';

/** Provider list inside the "Connected accounts" Panel (rounding + padding come
 *  from the enclosing Panel, mirroring the sessions list). */
export const List = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 4px;
`;

/** Hairline between adjacent provider rows (own copy, not AccountSection's
 *  section-local one). */
export const Divider = styled.div`
  height: 1px;
  background: ${COLORS.hairline};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 0;
`;

export const RowIcon = styled.span`
  display: inline-flex;
  font-size: 20px;
  line-height: 0;
`;

export const RowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
`;

export const Name = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${COLORS.text};
`;

export const Detail = styled.span`
  font-size: 12px;
  color: ${COLORS.textMuted};
`;

export const ErrorText = styled.p`
  margin: 8px 0 0;
  font-size: 13px;
  color: ${COLORS.ctaSolid};
`;
